"use strict";

angular.module("admin")
	.controller("AdminImportConfigurationCtrl", ["$scope", "importConfigurations", "$q", "SecurityService", "AdminImportConfigurationService", "$uibModal", "toastr", "AdminClientsService", "$location",
		function ($scope, importConfigurations, $q, SecurityService, AdminImportConfigurationService, $uibModal, toastr, AdminClientsService, $location) {
			$scope.data = {
				importConfigurations: importConfigurations.data,
				isSuperAdmin: SecurityService.hasRight('ROLE_SUPER_ADMINISTRATEUR')
			};

			AdminClientsService.getCurrentClient().then((client) => {
				$scope.data.sncf = client.sncf;
			});

			/**
			 * Lance un appel vers l'api pour persister les changements sur la configuration des imports automatiques
			 * @param apiCall Fonction d'appel vers l'api
			 * @param operationLabel Nom de l'opération
			 * @param onSuccess Fonction callback sur succès
			 */
			$scope.apiPersist = (apiCall, operationLabel, onSuccess) => {
				apiCall().then(() => {
					if (angular.isFunction(onSuccess)) {
						onSuccess();
					}
					toastr.success("", operationLabel + " réussie");
					$location.path("/admin/import-configuration");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Erreur lors de la " + operationLabel;
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			};

			$scope.deleteConfigurationImportConfiguration = function (id) {
				AdminClientsService.getReferentialIdAndUser().then((referential) => {
					AdminImportConfigurationService.deleteImportConfigurationScheduler(referential.id, id)
					   .then(() => {
						   AdminImportConfigurationService.deleteValidationExportScheduler(referential.id, id)
														  .then(() => {})
														  .catch(() => toastr.error("Problème lors de la suppression de l'import automatique.", "Erreur"));
					   })
					   .catch(() => toastr.error("Problème lors de la suppression de l'import automatique.", "Erreur"));
				});
			};

			$scope.delete = function (id) {
				// on met à jour la liste si succès de la suppression
				$scope.data.importConfigurations = $scope.data.importConfigurations.filter(e => e.id !== id);
				$scope.apiPersist(() => AdminImportConfigurationService.delete(id).then(() => {
					$scope.deleteConfigurationImportConfiguration(id);
				}), "Suppression du modèle d'import", null);
			};
		}
	]);
